import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const drawerWidth = 300;
const headerHeight = 60;

const useStyles = makeStyles((theme) => ({
  drawer: {
    flexShrink: 0,
    width: drawerWidth,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    paddingTop: headerHeight,
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    paddingTop: headerHeight,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(9) + 1,
  },

  toolbar: {
    backgroundColor: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
  },

  toolbarCollapsed: {
    boxShadow: theme.shadows[4],
    height: 48,
    minHeight: 64,
  },

  logoCollapsed: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  multiservice: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: theme.spacing(4, 2, 2),
  },
  divider: {
    backgroundColor: theme.palette.sidebar.divider,
    marginTop: theme.spacing(1.5),
  },
  dividerCollapsed: {
    marginTop: 0,
    transition: 'margin 200ms',
  },
  listContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  listContainerCollapsed: {
    '&::-webkit-scrollbar': {
      display: 'none',
    },
  },
  list: {
    height: '100%',
    maxHeight: '100%',
    padding: '18px 0 32px',
  },
  secondList: {
    padding: 0,
    backgroundColor: '#F4F5F7',
  },
  link: {
    color: theme.palette.sidebar.color,
    '& .MuiListItem-button': {
      paddingLeft: 24,
    },
    '& .MuiListItem-button:hover': {
      backgroundColor: theme.palette.sidebar.activeBackground,
    },
    '&:hover': {
      '& .MuiListItemIcon-root': {
        color: theme.palette.sidebar.active,
      },
      '& .MuiSvgIcon-root': {
        color: theme.palette.sidebar.active,
      },
      '& .MuiTypography-root': {
        color: theme.palette.sidebar.active,
      },
    },
  },
  linkClosed: {
    '& .MuiListItem-button': {
      paddingLeft: 24,
    },
  },
  active: {
    '& .MuiListItemIcon-root': {
      color: theme.palette.sidebar.active,
    },
    '& .MuiTypography-root': {
      color: theme.palette.sidebar.active,
      fontWeight: 500,
    },
  },

  linkIcon: {
    alignItems: 'center',
    color: theme.palette.sidebar.color,
    display: 'flex',
    justifyContent: 'center',
    marginRight: 10,
    minWidth: 24,
  },

  svgIcon: {
    maxWidth: 24,
  },

  linkCollapse: {
    marginRight: 25,
  },

  linkText: {
    color: theme.palette.sidebar.color,
    '& .MuiTypography-root': {
      fontSize: theme.typography.pxToRem(15),
    },
  },

  sectionTitle: {
    fontSize: 15,
    fontWeight: 500,
    marginLeft: theme.spacing(3),
    marginTop: theme.spacing(1.25),
    marginBottom: theme.spacing(0.6),
    color: theme.palette.text.primary,
  },
}));

const SidebarTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.tooltip.background,
    color: theme.palette.common.white,
    fontSize: theme.typography.pxToRem(12),
  },
}))(Tooltip);

export { useStyles, SidebarTooltip };
